<template>
  <v-container fluid class="no-padding">
    <v-dialog v-model="helpDialog" width="650">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          help_title_hu
        }}</v-card-title>
        <v-card-text>
          <v-list>
            <v-header>{{ help_hu[0] }}</v-header>
            <v-list-item v-for="(item, i) in help_hu[1]" :key="i">
              <v-list-item-content>
                <v-list-item-title v-text="item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="helpDialog = false">{{ help_action_hu }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card tile height="100%">
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ title_hu }}</h3>
      </v-card-title>
      <v-card-text>
        <v-spacer />
        {{ info_hu }}
        <v-btn fab x-small @click="helpDialog = true">
          <v-icon>help</v-icon>
        </v-btn>
      </v-card-text>
      <v-card-title v-if="!parsedData" height="100%" class="text-center">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 12 : 2" class="mx-auto" height="350" width="100%">
                <v-spacer />
                <v-card-text>{{ hint_hu }}</v-card-text>
                <v-spacer />
                <v-card-text class="my-4 text-center title" justify="space-around">
                  <v-icon large dark>{{ uploadIcon }}</v-icon>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-title v-if="parsedData">
        <v-textarea
          readonly
          rows="25"
          max-rows="50"
          :label="data_label_hu"
          :value="JSON.stringify(parsedData, null, 2)"
        ></v-textarea>
      </v-card-title>
      <v-card-actions v-if="parsedData">
        <v-spacer />
        <v-btn @click="clearData">{{ action_hu }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-btn small @click="getGeojsonSample" width="49%">{{ geojson_sample_hu }}</v-btn>
        <v-btn small @click="getXlsxSample" width="49%" style="float: right;">{{
          xlsx_sample_hu
        }}</v-btn>
      </v-card-text>
      <v-card-text>
        <v-spacer />
        <a href="https://geojson.org/">{{ geojson_hint_hu }}</a>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import bbox from '@turf/bbox';
import { mdiDownload } from '@mdi/js';
import ApiService from '@/services/ApiService';
import mapboxgl from 'mapbox-gl';
import { saveAs } from 'file-saver';

export default {
  name: 'DataImport',
  props: ['map'],
  data() {
    return {
      title: 'Data import',
      title_hu: 'Adat importálás',
      info: 'Supported file formats: GeoJSON and XLSX',
      info_hu: 'Támogatott fájlformátumok: GeoJSON és XLSX.',
      hint: 'Drop file to add data HERE',
      hint_hu: 'Húzd és ejtsd a fájlt IDE',
      action: 'Clear',
      action_hu: 'Törlés',
      geojson_hint: 'What is GeoJSON?',
      geojson_hint_hu: 'Mi az a GeoJSON?',
      parsedData: '',
      data_label: 'File Data:',
      data_label_hu: 'Fájl tartalma:',
      help_title_hu: 'Súgó',
      help_hu: [
        'XLSX formátum esetén a munkafüzetnek az alábbi szabályoknak kell megfelelnie:',
        [
          'Az adatoknak az első munkalapon kell lenniük.',
          'Egysoros fejlécnek kell tartalmaznia a térképi elem attribútum neveit.',
          'Minden további sornak egy térképi elemet kell reprezentálnia.',
          'Az 1. oszlopnak a hosszúsági fokot kell tartalmaznia WGS84 szabvány szerint.',
          'A 2. oszlopnak a szélességi fokot kell tartalmaznia WGS84 szabvány szerint.',
          'A további oszlopok adatai a térképi elem attribútumai.'
        ]
      ],
      help_action_hu: 'Rendben',
      geojson_sample: 'Download GeoJSON sample',
      geojson_sample_hu: 'GeoJSON minta letöltése',
      xlsx_sample: 'Download XLSX sample',
      xlsx_sample_hu: 'XLSX minta letöltése',
      uploadIcon: mdiDownload,
      popup: undefined,
      helpDialog: false
    };
  },
  mounted() {
    window.addEventListener('dragleave', this.preventDefault);
    window.addEventListener('dragover', this.preventDefault);
    window.addEventListener('drop', this.handleDrop);
  },
  beforeDestroy() {
    window.removeEventListener('dragleave', this.preventDefault);
    window.removeEventListener('dragover', this.preventDefault);
    window.removeEventListener('drop', this.handleDrop);
    if (this.map.getSource('uploadedGeoJSON')) {
      this.map.removeLayer('uploadedPoint');
      this.map.removeLayer('uploadedLine');
      this.map.removeLayer('uploadedLinePolygon');
      this.map.removeSource('uploadedGeoJSON');
    }
  },
  methods: {
    preventDefault(e) {
      e.preventDefault();
    },
    handleDrop(e) {
      e.preventDefault();
      let files = e.dataTransfer.files;
      this.uploadFiles(files);
    },
    showProperties(event) {
      let content = '';
      event.features.forEach((element) => {
        for (let key in element.properties) {
          content +=
            '<li class="list-group-item">' + key + ': ' + element.properties[key] + '</li>';
        }
      });
      if (this.popup) {
        this.popup.remove();
      }
      this.popup = new mapboxgl.Popup()
        .setLngLat(event.lngLat)
        .setHTML('<ul class="list-group">' + content + '</ul>')
        .addTo(this.map);
    },
    drawData(data) {
      let source = this.map.getSource('uploadedGeoJSON');
      if (data.type === 'Feature' || data.features.length > 0) {
        this.map.fitBounds(bbox(data));
      }
      if (source) {
        source.setData(data);
      } else {
        this.map.addSource('uploadedGeoJSON', {
          type: 'geojson',
          data: data
        });
        this.map.addLayer({
          id: 'uploadedPoint',
          type: 'circle',
          source: 'uploadedGeoJSON',
          paint: {
            'circle-radius': 6,
            'circle-color': '#B42222'
          },
          filter: ['==', '$type', 'Point']
        });

        this.map.addLayer({
          id: 'uploadedLine',
          type: 'line',
          source: 'uploadedGeoJSON',
          paint: {
            'line-color': 'black',
            'line-width': 3
          },
          filter: ['all', ['==', '$type', 'LineString'], ['!=', 'id', '']]
        });

        this.map.addLayer({
          id: 'uploadedLinePolygon',
          type: 'fill',
          source: 'uploadedGeoJSON',
          paint: {
            'fill-outline-color': 'rgba(0, 0, 0, 0%)',
            'fill-color': 'black',
            'fill-opacity': 0.4
          },
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'id', '']]
        });
        this.map.on('mouseenter', 'uploadedPoint', () => {
          this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'uploadedPoint', () => {
          this.map.getCanvas().style.cursor = '';
        });
        this.map.on('click', 'uploadedPoint', (event) => {
          this.showProperties(event);
        });
        this.map.on('mouseenter', 'uploadedLine', () => {
          this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'uploadedLine', () => {
          this.map.getCanvas().style.cursor = '';
        });
        this.map.on('click', 'uploadedLine', (event) => {
          this.showProperties(event);
        });
        this.map.on('mouseenter', 'uploadedLinePolygon', () => {
          this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'uploadedLinePolygon', () => {
          this.map.getCanvas().style.cursor = '';
        });
        this.map.on('click', 'uploadedLinePolygon', (event) => {
          this.showProperties(event);
        });
      }
    },

    uploadFiles(f) {
      if (this.parsedData) {
        return;
      }
      if (f.length > 1) {
        this.$swal('Csak egy fájl tölthető fel');
        return;
      }
      if (f.length) {
        if (f[0].name.endsWith('.xlsx')) {
          // xlsx
          let fd = new FormData();
          fd.append('file', f[0]);
          ApiService.convertXlsx2Geojson(fd)
            .then((resp) => {
              this.parsedData = resp.data.result;
              this.drawData(this.parsedData);
            })
            .catch(() => {
              this.$swal(
                'Az első oszlopnak hosszúsági, ' +
                  'a második oszlopnak szélességi fokot kell tartalmaznia.'
              );
            });
        } else if (f[0].name.endsWith('.json') || f[0].name.endsWith('.geojson')) {
          // json
          let reader = new FileReader();
          reader.onload = (e) => {
            this.parsedData = '';
            try {
              this.parsedData = JSON.parse(e.target.result);
              this.drawData(this.parsedData);
            } catch (e) {
              this.$swal('A geoJSON fájl nem valid.');
            }
          };
          reader.readAsText(f[0], 'UTF-8');
        } else {
          this.$swal('Nem támogatott fájlformátum');
        }
      }
    },
    clearData() {
      let emptyFeature = {
        type: 'FeatureCollection',
        features: []
      };
      this.drawData(emptyFeature);
      this.parsedData = '';
      if (this.popup) {
        this.popup.remove();
      }
    },
    async getGeojsonSample() {
      const { data } = await ApiService.exportGeojsonSample();
      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json;charset=utf-8'
      });
      saveAs(blob, 'GeoJSON_sample.geojson');
    },
    async getXlsxSample() {
      const { data } = await ApiService.exportXlsxSample();
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, 'XLSX_sample.xlsx');
    }
  }
};
</script>
